import dayjs from 'dayjs';
import i18next from 'i18next';

export const getYear = (time:string) => {
  const dateObject = dayjs(time);
  return dateObject.year()
} 
export const getMonth = (time:string) => {
  const dateObject = dayjs(time);
  return dateObject.month()
} 
export const getMonthName = (time:string) => {
  const dateObject = dayjs(time);
  const monthName = dateObject.format('MMMM')
  return monthName.charAt(0).toUpperCase() + monthName.slice(1);
} 

export const formatDateForChart = (dateString:string, isDayChart: boolean) => {
  if(isDayChart){
    return dateString.split(" ")[1].substring(0, 5)
  }
  const dateDateString = dateString.split(" ")[0]
  const currentDate = dayjs();
  const inputDate = dayjs(dateDateString);
  const currentLanguage = i18next.language;

  const day = inputDate.format('D');
  let month = inputDate.locale(currentLanguage).format('MMM');
  month = `${month.charAt(0).toUpperCase()}${month.slice(1)}`
  if (currentDate.year() === inputDate.year()) {
    return `${day}. ${month}`;
  } else {
    return `${inputDate.year()} ${day}. ${month}`;
  }
}
export const formatDataForChartTolltip = (dateString:string) => {
  let day = dayjs(dateString).format("dddd");
  day = `${day.charAt(0).toUpperCase()}${day.slice(1)}`
  const formattedDate = day+ ": " + dayjs(dateString).format("DD.MM.YYYY");
  return formattedDate;
}
